const SET_CURRENT_FOLIO_NUMBER = 'SET_CURRENT_FOLIO_NUMBER';

export default {
  SET_CURRENT_FOLIO_NUMBER,
};
